<div class="list-box">
  <!-- Linha superior: filtro textual local (esq) + ordenação (dir) -->
  <div
    *ngIf="filtroTextoExibir || (ordenacaoExibir && colunasOrdenaveis.length > 0)"
    class="list-box__topo"
  >
    <mat-form-field
      *ngIf="filtroTextoExibir"
      appearance="outline"
      class="list-box__filtro"
    >
      <mat-label *ngIf="filtroTextoLabel">{{ filtroTextoLabel }}</mat-label>
      <input
        matInput
        [(ngModel)]="filtroTextoInterno"
        (ngModelChange)="aplicarFiltro()"
        [placeholder]="filtroTextoPlaceholder"
        autocomplete="off"
        spellcheck="false"
      />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <div
      *ngIf="ordenacaoExibir && colunasOrdenaveis.length > 0"
      class="list-box__ordenacao"
    >
      <mat-form-field appearance="outline" class="list-box__ordenar">
        <mat-label>Ordenar por</mat-label>
        <mat-select
          [(ngModel)]="ordenacaoColunaSelecionada"
          (selectionChange)="aoMudarOrdenacaoCombo($event.value)"
        >
          <mat-option
            *ngFor="let col of colunasOrdenaveis; trackBy: trackCol"
            [value]="col.id"
          >
            {{ col.titulo }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-radio-group
        class="list-box__direcao"
        [value]="ordenacaoDesc"
        (change)="aoMudarDirecaoOrdenacao($event.value)"
      >
        <mat-radio-button [value]="false">Crescente</mat-radio-button>
        <mat-radio-button [value]="true">Decrescente</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>

  <!-- Navegação de grupos de colunas -->
  <div
    *ngIf="paginarColunas && colunas.length > colunasPorGrupo"
    class="list-box__grupo-nav"
  >
    <span class="list-box__grupo-rotulo">Colunas</span>
    <button
      mat-icon-button
      type="button"
      (click)="grupoColunaAnterior()"
      title="Grupo anterior de colunas"
    >
      <mat-icon>chevron_left</mat-icon>
    </button>
    <span class="list-box__grupo-pag">{{ grupoColunaAtualRotulo }}</span>
    <button
      mat-icon-button
      type="button"
      (click)="grupoColunaProximo()"
      title="Próximo grupo de colunas"
    >
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>

  <!-- Tabela Material -->
  <div class="list-box__tabela-container">
    <mat-table
      matTableExporter
      [dataSource]="dataSource"
      matSort
      (matSortChange)="aoMudarOrdenacaoSort($event)"
      #exporter="matTableExporter"
      class="list-box__tabela"
    >
      <!-- Coluna de Ações (Engrenagem) -->
      <ng-container matColumnDef="acoes" sticky>
        <mat-header-cell *matHeaderCellDef class="list-box__cel-acoes"></mat-header-cell>
        <mat-cell *matCellDef="let row" class="list-box__cel-acoes">
          <button
            mat-icon-button
            [matMenuTriggerFor]="menuAcoes"
            class="list-box__btn-menu"
            [disabled]="!temAcaoEngrenagemDisponivel(row)"
            [title]="temAcaoEngrenagemDisponivel(row) ? 'Ações' : 'Nenhuma ação disponível'"
          >
            <mat-icon>settings</mat-icon>
          </button>
          <mat-menu #menuAcoes="matMenu">
            <ng-container *ngFor="let acao of acoesEngrenagem; trackBy: trackAcao">
              <button
                *ngIf="acao.exibicao(row) !== 'oculto'"
                mat-menu-item
                [disabled]="acao.exibicao(row) === 'desabilitado'"
                (click)="executarAcao(row, acao, $event)"
              >
                {{ acao.rotulo }}
              </button>
            </ng-container>
          </mat-menu>
        </mat-cell>
      </ng-container>

      <!-- Colunas dinâmicas -->
      <ng-container *ngFor="let col of colunasVisiveis; trackBy: trackCol" [matColumnDef]="col.id">
        <!-- Header -->
        <ng-container *ngIf="isOrdenavel(col); else headerSemSort">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            [ngClass]="classeAlinhamento(col)"
            [style.minWidth.px]="col.larguraMinPx"
            [style.flexBasis.px]="col.larguraMinPx"
          >
            {{ col.titulo }}
          </mat-header-cell>
        </ng-container>
        <ng-template #headerSemSort>
          <mat-header-cell
            *matHeaderCellDef
            [ngClass]="classeAlinhamento(col)"
            [style.minWidth.px]="col.larguraMinPx"
            [style.flexBasis.px]="col.larguraMinPx"
          >
            {{ col.titulo }}
          </mat-header-cell>
        </ng-template>

        <!-- Cell -->
        <mat-cell
          *matCellDef="let row"
          [ngClass]="classeAlinhamento(col)"
          [style.minWidth.px]="col.larguraMinPx"
          [style.flexBasis.px]="col.larguraMinPx"
          [matTooltip]="obterTooltipCelula(row, col)"
          [matTooltipDisabled]="!obterTooltipCelula(row, col)"
        >
          <ng-container [ngSwitch]="col.modoCelula">
            <!-- Moeda -->
            <ng-container *ngSwitchCase="'moeda'">
              {{ obterValorNumerico(row, col) | currency : 'BRL' : 'symbol' : '1.2-2' }}
            </ng-container>

            <!-- Litros -->
            <ng-container *ngSwitchCase="'litros'">
              {{ obterValorNumerico(row, col) | number : '1.2-2' }} L
            </ng-container>

            <!-- Sim/Não com cor -->
            <ng-container *ngSwitchCase="'simNaoCor'">
              <span
                class="list-box__sim"
                *ngIf="obterValor(row, col) === true; else naoTpl"
              >Sim</span>
              <ng-template #naoTpl>
                <span
                  class="list-box__nao"
                  *ngIf="obterValor(row, col) === false; else vazioTpl"
                >Não</span>
              </ng-template>
              <ng-template #vazioTpl></ng-template>
            </ng-container>

            <!-- Texto de erro (genérico) -->
            <ng-container *ngSwitchCase="'textoErro'">
              <span class="list-box__texto-erro">{{ obterValor(row, col) || '' }}</span>
            </ng-container>

            <!-- Botão de ação (genérico) -->
            <ng-container *ngSwitchCase="'botaoAcao'">
              <button
                *ngIf="mostrarBotaoAcao(row, col)"
                mat-stroked-button
                [color]="col.botaoAcaoConfig?.cor || 'warn'"
                type="button"
                class="list-box__btn-acao"
                (click)="onBotaoAcaoClick(row, col, $event)"
              >
                {{ col.botaoAcaoConfig?.rotulo || 'Ação' }}
              </button>
            </ng-container>

            <!-- Ícones de imagens (linha de mat-icon-buttons pequenos) -->
            <ng-container *ngSwitchCase="'iconesImagens'">
              <span class="list-box__cel-imgs">
                <ng-container
                  *ngFor="let ic of col.iconesImagensConfig?.icones; trackBy: trackIcone"
                >
                  <button
                    *ngIf="ic.mostrarSe(row)"
                    mat-icon-button
                    type="button"
                    class="list-box__btn-img"
                    [matTooltip]="ic.tooltip"
                    (click)="onIconeImagemClick(row, col, ic.id, $event)"
                  >
                    <mat-icon>{{ ic.icone }}</mat-icon>
                  </button>
                </ng-container>
              </span>
            </ng-container>

            <!-- Data -->
            <ng-container *ngSwitchCase="'data'">
              {{ formatarData(obterValor(row, col)) }}
            </ng-container>

            <!-- Data/Hora -->
            <ng-container *ngSwitchCase="'dataHora'">
              {{ formatarDataHora(obterValor(row, col)) }}
            </ng-container>

            <!-- CPF -->
            <ng-container *ngSwitchCase="'cpf'">
              {{ formatarCpf(obterValor(row, col)) }}
            </ng-container>

            <!-- Padrão -->
            <ng-container *ngSwitchDefault>
              <ng-container *ngIf="col.formatoNumero as fmt; else textoBruto">
                {{ obterValorNumerico(row, col) | number : fmt }}
              </ng-container>
              <ng-template #textoBruto>{{ obterValor(row, col) }}</ng-template>
            </ng-container>
          </ng-container>
        </mat-cell>
      </ng-container>

      <!-- Header e Row definitions -->
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: displayedColumns"
        [ngClass]="getRowClass(row)"
      ></mat-row>
    </mat-table>
  </div>

  <!-- Mensagens de vazio -->
  <p *ngIf="itens.length === 0" class="list-box__sem-itens">
    Nenhum registro para exibir nesta consulta.
  </p>
  <p
    *ngIf="itens.length > 0 && dataSource.filteredData.length === 0"
    class="list-box__sem-itens"
  >
    Nenhum registro encontrado com o filtro aplicado.
  </p>

  <!-- Paginador -->
  <mat-paginator
    *ngIf="mostrarPaginador"
    class="list-box__paginator"
    [length]="paginacaoClientSide ? dataSource.filteredData.length : totalRegistros"
    [pageSize]="tamanhoPaginaSeguro"
    [pageIndex]="paginaAtualSegura - 1"
    [pageSizeOptions]="opcoesTamanhoPagina"
    [showFirstLastButtons]="true"
    (page)="onPageEvent($event)"
  >
  </mat-paginator>
</div>
